import React from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import Button from '@src/v3/components/coreUI/button';
import Icon from '@src/v3/components/coreUI/icon';

const GoogleButton = ({
  onSuccess = () => {
    return;
  },
  isLoading = false,
  disabled = false,
}: {
  // eslint-disable-next-line no-unused-vars
  onSuccess: (token: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      onSuccess(tokenResponse.access_token);
    },
    scope:
      'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile', // Add your custom scopes here
  });

  return (
    <Button
      type="button"
      variant="outline"
      size="xxl"
      className="w-full shadow-none"
      onClick={() => login()}
      disabled={disabled || isLoading}
      isLoading={isLoading}
      loadingType="dots"
    >
      <Icon iconName="google" iconProps={{ className: 'w-5 h-5' }} />
      Continue with Google
    </Button>
  );
};
const GoogleLoginButton = ({
  onSuccess = () => {
    return;
  },
  isLoading = false,
  disabled = false,
}: {
  // eslint-disable-next-line no-unused-vars
  onSuccess: (token: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  return (
    <GoogleOAuthProvider
      clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ''}
    >
      <GoogleButton
        onSuccess={onSuccess}
        isLoading={isLoading}
        disabled={disabled}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginButton;
